// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .filter-table{
    width: 20vw;
    height: 20vw;
} */
.filter-dropdown{
    
}
.filter-trigger{

  /* background-color:  rgb(0, 26, 102); */
  background-color: #020131;
  border-radius: 40%;
  padding: 0.2vw;
  color: rgb(255, 255, 255);
  box-shadow: 0 2px 4px  rgb(0, 26, 102);
}
/* .filter-options {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 20vw;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1;
} */
  .filter-options-options{
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow-y: hidden;height: 10vw;
    max-height: 50vw; 
    max-width: 40vw;
    min-width: 5vw;
    overflow-y: auto; 
    box-shadow: 0 2px 4px  rgb(0, 26, 102);
    z-index: 1;

  }
  .op-label{
    margin-right: 1vw;
  }
  .options-container {
    
    padding: 8px;
    display: flex;
    justify-content: space-between;
  }
  .options-options-container {
    padding: 8px;
    display: flex;
    flex-direction: column;
    /* max-width: 10vw; */
  }
  .textboxpc{
    width: 8vw;
    height: 4vh;
    margin-top: 1.5vh;
  }

  @media (max-width: 760px) {
    .filter-options {
      width: 100%; 
      left: 0; 
      max-height: 34vh;
    }
    .filter-options-options{
      right: 2vw;
      max-height: 50vw; 
      min-height: 10vh;
    max-width: 40vw;
    min-width: 5vw;
    }
    .textboxpc{
      width: 15vh;
    }
  }  

/* ===========================================================landing page css======================================================================*/

.landheading{
    font-size: 2vw;
    margin: 2vw;
    margin-left: 30vw;
}
.maintable-landing{
    margin: 2vw;
    width: 72vw !important;
    margin-left: 15vw;
}
@media (max-width: 760px) {
  .maintable-landing{
    width: 95vw !important;
  }
  .landheading{
    font-size: 4vw;
    margin: 3vw;
  }
}
@media (max-width: 1222px) {
  .maintable-landing{
    width: 95vw !important;
    margin-left: 3vw;
  }

}

/*=============================================================views===================================================================================*/
  
.vhr-head{
    margin: 1vw;
    font-size: 2vw;
}
.vhr-h1{
    border-bottom: thick double #080a0a;
    font-size: 3vw;
    font-weight: bold;
}
@media (max-width: 760px) {
  .vhr-head{
    font-size: 4vw;
  }
  .vhr-h1{
    font-size: 5vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/table1.css"],"names":[],"mappings":"AAAA;;;GAGG;AACH;;AAEA;AACA;;EAEE,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sCAAsC;AACxC;AACA;;;;;;;;GAQG;EACD;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB,CAAC,YAAY;IAC/B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sCAAsC;IACtC,UAAU;;EAEZ;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,YAAY;IACZ,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE;MACE,WAAW;MACX,OAAO;MACP,gBAAgB;IAClB;IACA;MACE,UAAU;MACV,gBAAgB;MAChB,gBAAgB;IAClB,eAAe;IACf,cAAc;IACd;IACA;MACE,WAAW;IACb;EACF;;AAEF,qJAAqJ;;AAErJ;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,WAAW;EACb;AACF;AACA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;AAEF;;AAEA,wJAAwJ;;AAExJ;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,cAAc;IACd,iBAAiB;AACrB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* .filter-table{\r\n    width: 20vw;\r\n    height: 20vw;\r\n} */\r\n.filter-dropdown{\r\n    \r\n}\r\n.filter-trigger{\r\n\r\n  /* background-color:  rgb(0, 26, 102); */\r\n  background-color: #020131;\r\n  border-radius: 40%;\r\n  padding: 0.2vw;\r\n  color: rgb(255, 255, 255);\r\n  box-shadow: 0 2px 4px  rgb(0, 26, 102);\r\n}\r\n/* .filter-options {\r\n  position: absolute;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  max-height: 20vw;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  z-index: 1;\r\n} */\r\n  .filter-options-options{\r\n    position: absolute;\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    overflow-y: hidden;height: 10vw;\r\n    max-height: 50vw; \r\n    max-width: 40vw;\r\n    min-width: 5vw;\r\n    overflow-y: auto; \r\n    box-shadow: 0 2px 4px  rgb(0, 26, 102);\r\n    z-index: 1;\r\n\r\n  }\r\n  .op-label{\r\n    margin-right: 1vw;\r\n  }\r\n  .options-container {\r\n    \r\n    padding: 8px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .options-options-container {\r\n    padding: 8px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* max-width: 10vw; */\r\n  }\r\n  .textboxpc{\r\n    width: 8vw;\r\n    height: 4vh;\r\n    margin-top: 1.5vh;\r\n  }\r\n\r\n  @media (max-width: 760px) {\r\n    .filter-options {\r\n      width: 100%; \r\n      left: 0; \r\n      max-height: 34vh;\r\n    }\r\n    .filter-options-options{\r\n      right: 2vw;\r\n      max-height: 50vw; \r\n      min-height: 10vh;\r\n    max-width: 40vw;\r\n    min-width: 5vw;\r\n    }\r\n    .textboxpc{\r\n      width: 15vh;\r\n    }\r\n  }  \r\n\r\n/* ===========================================================landing page css======================================================================*/\r\n\r\n.landheading{\r\n    font-size: 2vw;\r\n    margin: 2vw;\r\n    margin-left: 30vw;\r\n}\r\n.maintable-landing{\r\n    margin: 2vw;\r\n    width: 72vw !important;\r\n    margin-left: 15vw;\r\n}\r\n@media (max-width: 760px) {\r\n  .maintable-landing{\r\n    width: 95vw !important;\r\n  }\r\n  .landheading{\r\n    font-size: 4vw;\r\n    margin: 3vw;\r\n  }\r\n}\r\n@media (max-width: 1222px) {\r\n  .maintable-landing{\r\n    width: 95vw !important;\r\n    margin-left: 3vw;\r\n  }\r\n\r\n}\r\n\r\n/*=============================================================views===================================================================================*/\r\n  \r\n.vhr-head{\r\n    margin: 1vw;\r\n    font-size: 2vw;\r\n}\r\n.vhr-h1{\r\n    border-bottom: thick double #080a0a;\r\n    font-size: 3vw;\r\n    font-weight: bold;\r\n}\r\n@media (max-width: 760px) {\r\n  .vhr-head{\r\n    font-size: 4vw;\r\n  }\r\n  .vhr-h1{\r\n    font-size: 5vw;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
